import axios from "axios";

export const getInboxApi = () => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + "/api/sost/kpi/info/?tipo=inbox");
};

export const getStatiKpiApi = () => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + "/api/sost/kpi/info/?tipo=stati");
};

export const getStatiKpiPerMeseApi = () => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + "/api/sost/kpi/info/?tipo=statiPerMese");
};

export const getNotificheApi = () => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + "/api/sost/notifiche/");
};

export const getScadenzeApi = () => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + "/api/sost/scadenze/");
};

export const aggiornaNotificaApi = (id) => {
    return axios.put(process.env.REACT_APP_API_ENDPOINT + `/api/sost/notifiche/${id}`);
};